import {defineMessages} from 'react-intl'

/**
 * Enum for the configurator steps
 */
export const XpdpConfiguratorSteps = {
    Configuration: 'configurations',
    Colors: 'colors',
    Accessories: 'accessories',
    Engraving: 'engraving',
    Summary: 'summary'
}

/**
 * Map to messages for each configurator step
 */
export const STEP_NAMES = defineMessages({
    [XpdpConfiguratorSteps.Configuration]: {
        id: 'configurator.step.configurations',
        defaultMessage: 'Confirm your configuration'
    },
    [XpdpConfiguratorSteps.Colors]: {
        id: 'configurator.step.colors',
        defaultMessage: 'Select your colors'
    },
    [XpdpConfiguratorSteps.Accessories]: {
        id: 'configurator.step.accessories',
        defaultMessage: 'Add accessories'
    },
    [XpdpConfiguratorSteps.Engraving]: {
        id: 'configurator.step.engraving',
        defaultMessage: 'Engraving'
    },
    [XpdpConfiguratorSteps.Summary]: {
        id: 'configurator.step.summary',
        defaultMessage: 'Summary'
    }
})

/**
 * Map to button labels for configurator steps
 */
export const STEP_NAME_LABELS = defineMessages({
    [XpdpConfiguratorSteps.Configuration]: {
        id: 'configurator.step_label.configuration',
        defaultMessage: 'Configuration'
    },
    [XpdpConfiguratorSteps.Colors]: {
        id: 'configurator.step_label.colors',
        defaultMessage: 'Colors'
    },
    [XpdpConfiguratorSteps.Accessories]: {
        id: 'configurator.step_label.accessories',
        defaultMessage: 'Accessories'
    },
    [XpdpConfiguratorSteps.Engraving]: {
        id: 'configurator.step_label.engraving',
        defaultMessage: 'Engraving'
    },
    [XpdpConfiguratorSteps.Summary]: {
        id: 'configurator.step_label.summary',
        defaultMessage: 'Summary'
    }
})
